import { useEffect, useState } from 'react';
import { usePathLang } from '../lib/i18n';
import { getConsent, enableExternalMedia, onConsentChange } from '../lib/consent';

// Google Maps iframe gated by consent: shows a styled placeholder until the
// visitor accepts external services (or presses the button).
const GatedMap = ({ src, title, className = '', minHeight = '350px' }) => {
    const lang = usePathLang();
    const [allowed, setAllowed] = useState(false);

    useEffect(() => {
        setAllowed(Boolean(getConsent()?.externalMedia));
        const cleanup = onConsentChange((state) => {
            setAllowed(Boolean(state?.externalMedia));
        });
        return cleanup;
    }, []);

    const t = (ro, ru) => (lang === 'ru' ? ru : ro);

    if (!allowed) {
        return (
            <div
                className={`flex flex-col items-center justify-center gap-[12px] bg-[#ececec] rounded-[5px] text-center p-[20px] ${className}`}
                style={{ minHeight }}
            >
                <p className="font-body text-[14.5px] text-gray-700 max-w-[520px] leading-[1.55]">
                    {t(
                        'Harta Google este dezactivată până la acceptarea serviciilor externe.',
                        'Карта Google отключена до принятия внешних сервисов.'
                    )}
                </p>
                <button
                    type="button"
                    onClick={() => {
                        enableExternalMedia();
                        setAllowed(true);
                    }}
                    className="btn-main text-white font-body text-[14px] font-[500] px-[24px] py-[9px] rounded-[5px] cursor-pointer"
                >
                    {t('Activează harta', 'Показать карту')}
                </button>
            </div>
        );
    }

    return (
        <iframe
            src={src}
            title={title || 'Google Maps'}
            className={`w-full h-full rounded-[5px] outline-none ${className}`}
            style={{ border: 0, minHeight }}
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            loading="lazy"
        ></iframe>
    );
};

export default GatedMap;
